import React from 'react';
import { useFiltersConfig } from 'hooks';

export default Component => props => (
    <Component {...props} filtersConfig={useFiltersConfig()} />
);
